import { Builder } from '@builder.io/react';

import TrustPilot from './trust-pilot';

Builder.registerComponent(TrustPilot, {
  name: 'TrustPilot',
  noWrap: true,
});
